/** @jsxImportSource @emotion/react */

import { Card, Text } from "@jsq/ds/core";
import { FormRadioButton, FormRadioGroup, SubmitButton, useFormContext } from "@jsq/ds/forms";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import { FormValues } from "../types";
interface PublishAnnouncementCardProps {
  arenaSelectionError: string;
  setArenaSelectionError: (error: string) => void;
}

const PublishAnnouncementCard = ({
  arenaSelectionError,
  setArenaSelectionError,
}: PublishAnnouncementCardProps) => {
  const { setFieldValue } = useFormContext<FormValues>();
  function handleArenaSelection(value: string) {
    if (arenaSelectionError && value) {
      setArenaSelectionError("");
    }
  }

  return (
    <Card title="Publish announcement">
      {arenaSelectionError && (
        <div css={{ marginBottom: SPACING.MEDIUM }}>
          <Text css={{ color: Colors.Danger500 }}>{arenaSelectionError}</Text>
        </div>
      )}
      <FormRadioGroup
        name="arenaType"
        label="Arena type"
        css={{ marginBottom: SPACING.MEDIUM }}
        onValueChanged={handleArenaSelection}
      >
        <FormRadioButton value="allArenas">All arenas</FormRadioButton>
        <FormRadioButton value="faArenas">FA arenas</FormRadioButton>
        <FormRadioButton value="nonFAarenas">Non-FA arenas</FormRadioButton>
      </FormRadioGroup>
      <SubmitButton
        variant="primary"
        isFullWidth
        onClick={() => setFieldValue("isTestAnnouncement", false)}
      >
        Publish announcement
      </SubmitButton>
    </Card>
  );
};

export default PublishAnnouncementCard;
